import { h } from '../lib/dom.js';
import { getState } from '../store.js';
import { iconMarkup } from '../icons/index.js';
import { go, openAddRecipient, openEditRecipient, deleteRecipient } from '../actions.js';
import { t } from '../i18n/index.js';

function recipientRow(r) {
  return h('div', { class: 'card' }, [
    h('div', { class: 'row-top' }, [
      h('div', {}, [
        h('div', { class: 'name' }, r.name),
        h('div', { class: 'mono text-sm text-muted' }, r.address)
      ]),
      h('div', { class: 'flex-gap-sm' }, [
        h('button', { class: 'icon-btn', 'aria-label': t('recipients.editAria', { name: r.name }), onclick: () => openEditRecipient(r.id) },
          h('span', { html: iconMarkup('pencil', { size: 14 }) })),
        h('button', { class: 'icon-btn', 'aria-label': t('recipients.deleteAria', { name: r.name }), onclick: () => deleteRecipient(r.id) },
          h('span', { html: iconMarkup('trash', { size: 14 }) }))
      ])
    ])
  ]);
}

export function renderRecipients() {
  const s = getState();
  const rows = s.savedRecipients.map(recipientRow);

  return h('div', { class: 'screen form-column' }, [
    h('button', { class: 'icon-btn icon-back mb-sm', onclick: () => go('move') }, [
      h('span', { html: iconMarkup('arrowLeft', { size: 16 }) }), ' ' + t('common.back')
    ]),
    h('div', { class: 'flex-between' }, [
      h('h1', { class: 'screen-title' }, t('recipients.title')),
      h('button', { class: 'btn btn-primary btn-sm', onclick: openAddRecipient }, t('recipients.add'))
    ]),
    rows.length
      ? h('div', { class: 'stack' }, rows)
      : h('div', { class: 'empty-state' }, t('recipients.empty'))
  ]);
}
